var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.redirect,{tag:"component",attrs:{"youdian":_vm.youdian,"buzu":_vm.buzu,"wjxw":_vm.wjxw},on:{"close":_vm.cancleHandler},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})}
var staticRenderFns = []

export { render, staticRenderFns }